import dynamic from "next/dynamic";

const MobileHamburgerIcon = dynamic(
  () => import("@components/MobileHamburgerIcon")
);

const HamburgerMenuIcon = (props) => {
  if (props.mobile) {
    return (
      <MobileHamburgerIcon
        auto={props.auto}
        width={props.width}
        height={props.height}
      />
    );
  }

  const color =
    props.hover === true || props.active === true ? "orange" : "#f5f5f5";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={33.67}
      height={25.669}
      {...props}
    >
      <g
        data-name="ic-actions-menu"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeWidth={2.813}
      >
        <path
          data-name="Line 128"
          strokeLinejoin="round"
          d="M1.406 12.834h30.857"
        />
        <path data-name="Path 90" d="M1.975 1.406h29.719" />
        <path
          data-name="Line 130"
          strokeLinejoin="round"
          d="M1.406 24.262h30.857"
        />
      </g>
    </svg>
  );
};

export default HamburgerMenuIcon;
